import styled from 'styled-components';
import CharginPointSvg from '../../assets/amenities/charging-point.svg';

const CharginPointIcon = styled(CharginPointSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CharginPointIcon;
